import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

const pathStart = 'Tools|Merges|Review Merge|';

type LocNameStart = 'SPToolsMergeHeader';
export type SPToolsMergeMergeHeaderLocNames = `${LocNameStart}LabelRestricted`;

export const spToolMergeHeaderLocs: LocDefs<SPToolsMergeMergeHeaderLocNames> = {
	SPToolsMergeHeaderLabelRestricted: {
		defaultValue: 'Testing Restricted',
		description: 'Label shown when the testing of the candidate is restricted.',
		displayPath: `${pathStart}Restrict Testing`,
		displayType: 'Title',
		shared: false,
		htmlAllowed: false,
		feature: HubFeature.MergeCandidates,
		portal: 'SP',
	},
};

export const LOC_KEYS = MapLocKeys<SPToolsMergeMergeHeaderLocNames>(spToolMergeHeaderLocs);

export type SPToolMergeHeaderLocType = LocMap<SPToolsMergeMergeHeaderLocNames>;
